(($) => {
  const scrollToTop = () => {
    $('html, body').animate({ scrollTop: 0, }, 600);

    return false;
  };

  const scrollTo = (e) => {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top,
    }, 500);
  };

  $('.scrollToTop').click(scrollToTop);
  $('a[href^="#"].scrollTo').click(scrollTo);

  /* eslint-disable-next-line no-undef */
})(jQuery);
